import React from 'react'
import { Script } from 'gatsby'

const InsiderScript: React.FC = () => (
  <>
    {/* 1) SDK da Insider */}
    <Script
      key="insider-sdk"
      type="text/javascript"
      src="//vivara.api.useinsider.com/ins.js?id=10007082"
      strategy="post-hydrate"
    />

    {/* 2) Listener precoce */}
    <Script
      key="insider-listener"
      id="insider-listener"
      strategy="post-hydrate"
    >
      {`(function waitForInsider() {
  if (window.Insider?.eventManager) {
    window.Insider.eventManager.once(
      'ins-sr:only-api-campaign:load',
      function (_, data) {
        // 1) guarda globalmente
        window.__insiderCampaignData = data;

        // 2) salva em sessionStorage numa key separada por campaignId
        const key = 'insiderCampaignData_' + data.campaignId;
        try {
          sessionStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
          console.warn('InsiderScript: falha ao gravar sessionStorage', e);
        }

        // 3) dispara evento customizado apenas para esta campanha
        window.dispatchEvent(
          new CustomEvent('insider-campaign-loaded-' + data.campaignId, {
            detail: data,
          })
        );

        console.log('[early listener] campanha:', data);
      }
    );
  } else {
    setTimeout(waitForInsider, 50);
  }
})();`}
    </Script>
  </>
)

export default InsiderScript
